<template>
	<div class="text-left">
		<div class="row-fluid">
			<div class="span12">
				<div class="jumbotron bg_user" style="margin-bottom:10px;padding-top: 40px;padding-bottom: 40px;">
					<div class="container">
						<div class="row">
							<div class="col-2" style="margin-top:3px;margin-left:-10px">
								<img :src=img width="60" height="60" />
							</div>
							<div class="col-6">
								<div style="margin-left: 25px;">
									<h4 style="color:#fffdff;">ceosgg {{name | name}}</h4>
								</div>
								<!-- <div style="margin-left: 15px;">523 积分</div> -->
								<div>
									<div style="margin-left: 25px;color:#fffdff;"><span
											class="label label-primary label_50"
											style="border-radius: 50px/50px; background-color: #ffd986; color: #00a4b7; margin-right: 5px;">V</span>认证用户
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
				<div class="span12 text-left" style="margin-top:20px">
					<h5 class="f_bt_1">我的记录</h5>
				</div>

				<div class="span12 text-left" style="margin-top:10px">
					<div class="cent" v-if="list == ''">
						暂无积分信息
					</div>
					<div class="aa" v-for="(item,index) in 20" v-else :key="index">
						<div class="row">
							<div class="col-9" style="padding-left:25px">
								<h5 class="title1">【活动】参加2021年元旦参观活动</h5>
								<footer class="time">2021年21月1日 12:00</footer>
							</div>
							<div class="jifen" v-if="item.describe == '完成服务'">+3</div>
							<div class="jifen" v-else>1人</div>
						</div>
					</div>
					<div v-if="list != ''">
						<button v-if="moreShowBoolen" @click="moreShow1" class="btn_page btn1"
							style="display:block;margin:25px auto 0;outline: none; color: #666; background-color: #eee; border-radius: 25px; height: 30px; width: 60%;">更多选项</button>
						<div v-else style="text-align:center;margin-top:15px">已无更多</div>
					</div>
					<div id="d_p"></div>



				</div>
				<div style="height: 6.25rem;"></div>

			</div>

		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				img: 'https://img.hsnms.com/20211201/1638370596.jpeg',
				name: '',
				integral: '',
				key_id: 0,
				jurisdiction: '',
				state: "",
			}
		},
		methods: {

		},
		mounted() {
			// //console.log(this.$api.getUserInfo());
			// this.$api.getAPI("mutual/attribute/0?appid=202108&type_id=4001", {
			//   openid: this.$api.getUserInfo().openid
			//   // openid: "8afac8196cbc454b016cbc9108f94b07"
			// }).then(res => {

			//   // console.log(res);
			//   // this.$api.getUserInfo_updata("8afac8196cbc454b016cbc9108f94b07");
			//   // console.log(res.data.data.models);
			//   this.img = res.data.data.models.avatar_url
			//   // console.log(this.img);
			//   this.jurisdiction = res.data.data.models.jurisdiction
			//   this.name = res.data.data.models.username
			//   this.key_id = res.data.data.models.key_id;
			//   this.state = res.data.data.models.state;
			// })


		},
		filters: {
			name(value) {
				if (!value) return '';
				let str = value;
				str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, '$1*$3')
				return str;
			}
		}
	}
</script>

<style>
	.btn1 {
		border: none;
		outline: 0;
		background: none;
	}

	.cent {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #777;
		font-size: 20px;
	}

	.aa {
		border-bottom: 1px solid #f2f2f2;
		height: 70px;
		position: relative;
	}

	.title1 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 16px;
		margin-top: 16px;
		margin-bottom: 5px;
	}

	.time {
		color: #d6d6d6;
		margin-bottom: 5px;
	}

	.jifen {
		position: absolute;
		top: 35px;
		transform: translateY(-50%);
		right: 10px;
		font-size: 20px;
		color: #ffd986;
	}

	.bgbtn {
		color: #fffdff;
		padding: 14px 0px;
		font-size: 16px;
		background-image: linear-gradient(to right, #26b5bd, #62d8cb);
		border-radius: 10px 0 0 10px;
	}

	.bgbtn1 {
		color: #fffdff;
		padding: 14px 0px;
		font-size: 16px;
		background-image: linear-gradient(to right, #62d8cb, #26b5bd);
		border-radius: 0 10px 10px 0;
	}

	.jumbotron {
		padding-top: 30px;
		padding-bottom: 30px;
	}

	.f_bt_1 {
		font-size: 16px;
	}

	.m_a {
		padding-right: 0px;
		padding-left: 0px;
	}

	.bg_user {
		background: url("https://img.hsnms.com/20210922/1632279215.jpg") no-repeat center;
		background-size: 100% 100%;
		/* box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.4); */
	}
</style>


// WEBPACK FOOTER //
// src/components/views/web/bwg/users/index.vue